if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
        
        constructor() {
            super();
            
            this.productsLimit = Number(this.dataset.productsLimit);
            const currentProductID = Number(this.dataset.currentProductId);
            const currentProductHandle = this.dataset.currentProductHandle;
            this.currentProduct = currentProductID ? { id: currentProductID, handle: currentProductHandle } : null;    
        }

        connectedCallback() {
            // render the recently viewed products
            this.render();
            
            // Add the current product to the recently viewed products list
            this.addRecentlyViewedProduct();
        }

        getRecentlyViewedProducts() {
            const data = sessionStorage.getItem('recently_viewed_products');
            return data ? JSON.parse(data) : [];
        }

        addRecentlyViewedProduct() {
            const product = this.currentProduct;
            const storageLimit = this.productsLimit + 1;
            if (product) {
                let productsList = this.getRecentlyViewedProducts();
                
                // Check if the product is already in the list, and skip adding it again
                const productExists = productsList.some(el => el.id === product.id);
        
                if (!productExists) {
                    productsList.unshift(product);
                }
        
                // Limit the number of products stored in sessionStorage
                if (productsList.length > storageLimit) {
                    productsList = productsList.slice(0, storageLimit);
                }
        
                // Save the updated list back to sessionStorage
                sessionStorage.setItem('recently_viewed_products', JSON.stringify(productsList));
            }
        }

        async fetchProductCardHTML(productHandle) {
            try {
                const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}?sections=product-card-render`);
                if (!response.ok) {
                    console.error(`Failed to fetch product data. HTTP status: ${response.status}`);
                    return null;
                }
                return await response.json();
            } catch (error) {
                console.error("Failed to fetch product data due to an error:", error);
                return null;
            }
        }

        async render() {
            const section = this.closest(".recently-viewed-products-section");
            const wrapper = this.querySelector("x-grid");

            let products = this.getRecentlyViewedProducts();
            if (this.currentProduct) {
                products = products.filter(product => product.id !== this.currentProduct.id);
            }

            // Limit the number of products to display
            products = products.slice(0, this.productsLimit);
            
            if (products.length) {
                section.classList.remove("hidden");
                

                for (const product of products) {
                    try {
                        const productData = await this.fetchProductCardHTML(product.handle);
                        if (productData?.['product-card-render']) {
                            // Create a temporary container and extract the desired content
                            const tempContainer = document.createElement("div");
                            tempContainer.innerHTML = productData['product-card-render'];
                            const sectionContent = tempContainer.querySelector("#shopify-section-product-card-render");
    
                            if (sectionContent) {
                                Array.from(sectionContent.children).forEach(child => wrapper.appendChild(child));
                            }
                        }
                    } catch (error) {
                        console.error("Error processing product:", product.id, error);
                    }
                }
            }
        }
    }

    customElements.define("recently-viewed-products", RecentlyViewedProducts);
}